var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.99501 1.00636C0.604486 1.39689 0.604486 2.03005 0.995011 2.42058L4.58016 6.00573L0.995009 9.59088C0.604485 9.98141 0.604486 10.6146 0.99501 11.0051C1.38553 11.3956 2.0187 11.3956 2.40922 11.0051L5.99438 7.41994L9.57951 11.0051C9.97004 11.3956 10.6032 11.3956 10.9937 11.0051C11.3843 10.6146 11.3843 9.98139 10.9937 9.59087L7.40859 6.00573L10.9937 2.42059C11.3843 2.03007 11.3843 1.3969 10.9937 1.00638C10.6032 0.615854 9.97004 0.615854 9.57951 1.00638L5.99438 4.59152L2.40922 1.00636C2.0187 0.615839 1.38554 0.615839 0.99501 1.00636Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.cf09e457ef3c7a727488cc7a71eb8787.svg";
export { ForwardRef as ReactComponent };